import { render, staticRenderFns } from "./DayPart.vue?vue&type=template&id=0a519368&scoped=true"
import script from "./DayPart.vue?vue&type=script&lang=js"
export * from "./DayPart.vue?vue&type=script&lang=js"
import style0 from "./DayPart.vue?vue&type=style&index=0&id=0a519368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a519368",
  null
  
)

export default component.exports